import { useModal } from '@gousto-internal/citrus-react';
import { RECIPE_MODAL_NAME_PREFIX } from '../utils/constants';

export function useRecipeModalInForeground(): boolean {
  const { getCurrentModal } = useModal();

  // Recipe modal only — the basket bottom-sheet (IRE-2127) deliberately keeps the
  // bars stacked above it on mobile, so other modals must not trigger this.
  return Boolean(getCurrentModal()?.startsWith(RECIPE_MODAL_NAME_PREFIX));
}
